import * as geoJsonUtils from "common/geoJsonUtils";
import { useMapLayerToggleControl, useHideShowMapLayer } from "./_hooks";

export default function DrawnIrrigatorsLayerToggle({ mapData, mapId }) {
    const layerId = geoJsonUtils.LAYER.Irrigator;
    const showLayer = useMapLayerToggleControl(mapData, mapId, layerId);
    useHideShowMapLayer(mapData, layerId, showLayer);
    return null;
}
